/* Mupiko · fotoğraf kırpma (3 Ekim 2026).
   Müşteri çocuk, anne veya baba fotoğrafını seçince yüzü kare çerçeveye yerleştirir. Kırpılan kare JPEG aynı
   dosya alanına konur; sepete giden fotoğraf ve "Önizle" bu dosyayı kullanır. store.js'teki kontroller
   (tür, boyut, en az 400 px) kırpılan dosyaya aynen uygulanır. */
(() => {
  const TYPES = ['image/jpeg', 'image/png', 'image/webp'];
  const MAX_BYTES = 10 * 1024 * 1024;
  const MIN_SIDE = 400; // store.js en az 400 px ister; kırpılan kare de bundan küçük olamaz
  const OUTPUT_MAX = 1600;
  // The page language (theme.liquid <html lang>) picks the texts; Turkish is the default.
  const TEXTS = {
    tr: {
      title: 'Yüzü çerçeveye yerleştirin',
      hint: 'Fotoğrafı sürükleyerek kaydırın, büyütmek için çubuğu ya da iki parmağınızı kullanın. Yüz ve saçlar kesikli çizginin içinde kalsın.',
      zoom: 'Yakınlaştır',
      skip: 'Kırpmadan kullan',
      apply: 'Kırp ve kullan',
      edit: 'Fotoğrafı yeniden kırp',
      close: 'Kapat'
    },
    en: {
      title: 'Fit the face in the frame',
      hint: 'Drag the photo to move it; use the slider or two fingers to zoom. Keep the face and hair inside the dashed outline.',
      zoom: 'Zoom',
      skip: 'Use without cropping',
      apply: 'Crop and use',
      edit: 'Re-crop the photo',
      close: 'Close'
    }
  };
  const TEXT = TEXTS[(document.documentElement.lang || 'tr').slice(0, 2).toLowerCase()] || TEXTS.tr;
  if (typeof HTMLDialogElement !== 'function' || typeof DataTransfer !== 'function') return;
  try { new DataTransfer().items.add(new File([''], 'x.txt')); } catch { return; }

  const style = document.createElement('style');
  style.textContent = `
.photo-crop-dialog{width:min(460px,calc(100% - 24px));max-height:calc(100dvh - 24px);border:0;border-radius:16px;padding:20px;color:var(--ink,#242034);box-shadow:0 20px 70px #250d4733;overflow:auto}
.photo-crop-dialog::backdrop{background:#29143d9e;backdrop-filter:blur(4px)}
.photo-crop-head{display:flex;justify-content:space-between;align-items:flex-start;gap:12px}
.photo-crop-head h2{font-size:21px;margin:0;line-height:1.25}
.photo-crop-close{background:none;border:0;font-size:28px;line-height:1;padding:0 4px;color:#6d5a7d;cursor:pointer}
.photo-crop-hint{font-size:12px;line-height:1.6;color:#7a6c86;margin:8px 0 14px}
.photo-crop-stage{position:relative;width:100%;aspect-ratio:1;overflow:hidden;border-radius:12px;background:#f4f0f8;touch-action:none;cursor:grab;user-select:none;-webkit-user-select:none}
.photo-crop-stage:active{cursor:grabbing}
.photo-crop-stage:focus-visible{outline:3px solid #6223a3;outline-offset:3px}
.photo-crop-stage img{position:absolute;left:0;top:0;max-width:none;max-height:none;pointer-events:none;user-select:none;-webkit-user-drag:none}
.photo-crop-guide{position:absolute;inset:0;pointer-events:none;border-radius:12px;box-shadow:inset 0 0 0 2px #ffffffb3}
.photo-crop-guide:after{content:"";position:absolute;left:50%;top:47%;width:50%;height:64%;transform:translate(-50%,-50%);border:2px dashed #fffffff2;border-radius:50%;filter:drop-shadow(0 0 2px #0006)}
.photo-crop-zoom{display:flex;align-items:center;gap:10px;margin:14px 0 4px;font-size:12px;font-weight:600;color:#6d5a7d}
.photo-crop-zoom input{flex:1;min-width:0;padding:0;border:0;background:none;accent-color:var(--purple,#a23af1)}
.photo-crop-actions{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-top:16px}
.photo-crop-actions .button{min-height:48px;padding:10px 12px;font-size:13px;gap:8px}
.photo-crop-edit{align-self:flex-start;background:none;border:0;padding:2px 0;margin:-2px 0 6px;color:var(--purple,#a23af1);font-size:11px;font-weight:700;text-decoration:underline;cursor:pointer}
@media(max-width:420px){.photo-crop-dialog{padding:16px}.photo-crop-head h2{font-size:19px}.photo-crop-actions{grid-template-columns:1fr}}
`;
  document.head.appendChild(style);

  const originals = new WeakMap(); // input → the photo as the customer chose it, for "yeniden kırp"
  let dialog, stage, image, slider, state = null, resolver = null;

  const build = () => {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'photo-crop-dialog';
    dialog.setAttribute('aria-labelledby', 'photo-crop-title');
    dialog.innerHTML = `
<div class="photo-crop-head"><h2 id="photo-crop-title">${TEXT.title}</h2><button class="photo-crop-close" type="button" data-crop-skip aria-label="${TEXT.close}">×</button></div>
<p class="photo-crop-hint">${TEXT.hint}</p>
<div class="photo-crop-stage" tabindex="0" aria-label="${TEXT.title}"><img alt=""><div class="photo-crop-guide"></div></div>
<label class="photo-crop-zoom">${TEXT.zoom}<input type="range" min="1" max="3" step="0.01" value="1"></label>
<div class="photo-crop-actions"><button class="button button-outline" type="button" data-crop-skip>${TEXT.skip}</button><button class="button" type="button" data-crop-apply>${TEXT.apply}</button></div>`;
    document.body.appendChild(dialog);
    stage = dialog.querySelector('.photo-crop-stage');
    image = stage.querySelector('img');
    slider = dialog.querySelector('input[type=range]');
    dialog.querySelectorAll('[data-crop-skip]').forEach(button => button.addEventListener('click', () => finish(null)));
    dialog.querySelector('[data-crop-apply]').addEventListener('click', async () => finish(await crop()));
    dialog.addEventListener('cancel', event => { event.preventDefault(); finish(null); });
    slider.addEventListener('input', () => { zoomAt(Number(slider.value), state.size / 2, state.size / 2); draw(); });
    stage.addEventListener('wheel', event => {
      event.preventDefault();
      const box = stage.getBoundingClientRect();
      zoomAt(state.zoom * Math.exp(-event.deltaY * 0.0015), event.clientX - box.left, event.clientY - box.top);
      draw();
    }, { passive: false });
    stage.addEventListener('keydown', event => {
      const step = { ArrowLeft: [12, 0], ArrowRight: [-12, 0], ArrowUp: [0, 12], ArrowDown: [0, -12] }[event.key];
      if (step) { state.x += step[0]; state.y += step[1]; }
      else if (event.key === '+' || event.key === '=') zoomAt(state.zoom * 1.1, state.size / 2, state.size / 2);
      else if (event.key === '-') zoomAt(state.zoom / 1.1, state.size / 2, state.size / 2);
      else return;
      event.preventDefault();
      draw();
    });
    // One finger (or the mouse) moves the photo; two fingers zoom around their midpoint.
    const pointers = new Map();
    let start = null;
    const snapshot = () => { start = { points: [...pointers.values()].map(point => ({ ...point })), x: state.x, y: state.y, zoom: state.zoom }; };
    stage.addEventListener('pointerdown', event => {
      stage.setPointerCapture(event.pointerId);
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      snapshot();
    });
    stage.addEventListener('pointermove', event => {
      if (!pointers.has(event.pointerId) || !start) return;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      const now = [...pointers.values()];
      if (now.length !== start.points.length) return snapshot();
      state.x = start.x; state.y = start.y; state.zoom = start.zoom;
      if (now.length === 1) {
        state.x += now[0].x - start.points[0].x;
        state.y += now[0].y - start.points[0].y;
      } else if (now.length >= 2) {
        const box = stage.getBoundingClientRect();
        const [a, b] = now, [a0, b0] = start.points;
        const ratio = Math.hypot(a.x - b.x, a.y - b.y) / (Math.hypot(a0.x - b0.x, a0.y - b0.y) || 1);
        const mid0 = { x: (a0.x + b0.x) / 2 - box.left, y: (a0.y + b0.y) / 2 - box.top };
        zoomAt(start.zoom * ratio, mid0.x, mid0.y);
        state.x += (a.x + b.x) / 2 - box.left - mid0.x;
        state.y += (a.y + b.y) / 2 - box.top - mid0.y;
      }
      draw();
    });
    const release = event => { pointers.delete(event.pointerId); snapshot(); };
    stage.addEventListener('pointerup', release);
    stage.addEventListener('pointercancel', release);
    window.addEventListener('resize', () => {
      if (!state || !dialog.open) return;
      const size = stage.clientWidth;
      if (!size || size === state.size) return;
      const ratio = size / state.size;
      state.x *= ratio; state.y *= ratio; state.size = size; state.base = size / Math.min(state.width, state.height);
      draw();
    });
  };

  // The photo always covers the square: zoom 1 = the short side fills it.
  const zoomAt = (zoom, cx, cy) => {
    const next = Math.min(state.max, Math.max(1, zoom));
    const before = state.base * state.zoom, after = state.base * next;
    const px = (cx - state.x) / before, py = (cy - state.y) / before;
    state.zoom = next;
    state.x = cx - px * after;
    state.y = cy - py * after;
  };
  const draw = () => {
    const scale = state.base * state.zoom;
    const width = state.width * scale, height = state.height * scale;
    state.x = Math.min(0, Math.max(state.size - width, state.x));
    state.y = Math.min(0, Math.max(state.size - height, state.y));
    image.style.width = `${width}px`;
    image.style.height = `${height}px`;
    image.style.transform = `translate3d(${state.x}px, ${state.y}px, 0)`;
    slider.value = String(state.zoom);
  };

  const crop = async () => {
    const scale = state.base * state.zoom;
    const side = state.size / scale;
    const out = Math.max(1, Math.round(Math.min(OUTPUT_MAX, side)));
    const canvas = document.createElement('canvas');
    canvas.width = canvas.height = out;
    const context = canvas.getContext('2d');
    context.fillStyle = '#fff';
    context.fillRect(0, 0, out, out);
    context.imageSmoothingQuality = 'high';
    context.drawImage(image, -state.x / scale, -state.y / scale, side, side, 0, 0, out, out);
    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', 0.92));
    if (!blob) return null;
    const name = `${state.file.name.replace(/\.[^.]+$/, '') || 'fotograf'}-kirpilmis.jpg`;
    return new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() });
  };

  const finish = result => {
    if (!resolver) return;
    const done = resolver;
    resolver = null;
    if (dialog.open) dialog.close();
    done(result);
  };

  // Resolves with the cropped file, null to keep the photo as it is, or undefined when the photo cannot be
  // framed here (unreadable or under 400 px; store.js then explains the problem).
  const open = file => new Promise(resolve => {
    build();
    const url = URL.createObjectURL(file);
    const giveUp = () => { URL.revokeObjectURL(url); resolve(undefined); };
    image.onload = () => {
      const width = image.naturalWidth, height = image.naturalHeight;
      if (Math.min(width, height) < MIN_SIDE) return giveUp(); // store.js asks for a clearer photo
      resolver = result => { URL.revokeObjectURL(url); resolve(result); };
      dialog.showModal();
      const size = stage.clientWidth;
      state = { file, width, height, size, base: size / Math.min(width, height), zoom: 1,
                max: Math.max(1, Math.min(5, Math.min(width, height) / MIN_SIDE)) };
      slider.max = String(state.max);
      slider.disabled = state.max <= 1.01;
      const shown = { width: width * state.base, height: height * state.base };
      state.x = (size - shown.width) / 2;
      // Faces sit in the upper part of most portrait photos.
      state.y = shown.height > shown.width ? (size - shown.height) * 0.3 : (size - shown.height) / 2;
      draw();
      stage.focus();
    };
    image.onerror = giveUp;
    image.src = url;
  });

  const editButton = input => {
    const box = input.closest('[data-upload-box]');
    if (!box || !input.id) return;
    let button = box.parentElement.querySelector(`[data-crop-edit="${input.id}"]`);
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'photo-crop-edit';
      button.dataset.cropEdit = input.id;
      button.textContent = TEXT.edit;
      (box.nextElementSibling || box).after(button);
      button.addEventListener('click', () => {
        const original = originals.get(input);
        if (original && !resolver) edit(input, original);
      });
    }
    button.hidden = !originals.get(input);
  };

  const edit = async (input, file) => {
    const cropped = await open(file);
    if (cropped === undefined) originals.delete(input);
    const transfer = new DataTransfer();
    transfer.items.add(cropped || file);
    input.files = transfer.files;
    input.dataset.cropPass = '1';
    input.dispatchEvent(new Event('change', { bubbles: true }));
    editButton(input);
  };

  // Runs before store.js and live-preview.js: the photo reaches them only after the customer has framed it.
  document.addEventListener('change', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'file'
        || !input.matches('[data-child-photo], [data-parent-photo]')) return;
    if (input.dataset.cropPass) { delete input.dataset.cropPass; return; }
    const file = input.files && input.files[0];
    if (!file) { originals.delete(input); editButton(input); return; }
    if (!TYPES.includes(file.type) || file.size > MAX_BYTES || resolver) return; // store.js explains the problem
    event.stopImmediatePropagation();
    originals.set(input, file);
    edit(input, file);
  }, true);
})();
